import { Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToTop } from "@/lib/scroll";
import { setConsent } from "@/lib/consent";

const Footer = () => (
  <footer className="bg-navy-950 text-slate-400" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <button onClick={scrollToTop} className="flex items-center gap-3 text-left" data-testid="footer-logo">
          <img src="/brand/emblem.png" alt="Logo Studio Legale Napolitano" className="h-14 w-14 object-contain" data-testid="footer-logo-image" />
          <span className="leading-tight">
            <span className="block font-serif text-white text-lg">Giuseppe Napolitano</span>
            <span className="block text-[10px] font-semibold uppercase tracking-[0.35em] text-gold">Avvocato</span>
          </span>
        </button>
        <p className="mt-6 text-sm leading-relaxed">
          Eccellenza e tutela legale su scala nazionale. Rigore tecnico, visione strategica e massima trasparenza dal 1994.
        </p>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Sedi</p>
        <ul className="mt-5 flex flex-col gap-3 text-sm">
          <li>Napoli — Viale Augusto 162</li>
          <li>Napoli — P.tta Aniello Falcone 1</li>
          <li>Milano — Corso di Porta Romana 69</li>
        </ul>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Contatti</p>
        <ul className="mt-5 flex flex-col gap-3 text-sm">
          <li className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-gold" />
            <a href="mailto:avv.giuseppenapolitano@gmail.com" className="hover:text-gold transition-colors">avv.giuseppenapolitano@gmail.com</a>
          </li>
          <li className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-gold" />
            Solo su appuntamento
          </li>
        </ul>
        <div className="mt-6 flex gap-5 text-sm">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">Privacy Policy</Link>
          <Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-gold transition-colors">Cookie Policy</Link>
          <button onClick={() => setConsent(null)} data-testid="footer-cookie-preferences" className="hover:text-gold transition-colors">Preferenze cookie</button>
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8">
        <p className="text-xs leading-relaxed text-slate-500">
          Studio Legale Avv. Giuseppe Napolitano — Iscritto all'Ordine degli Avvocati di Napoli, n. 14935 — P.IVA: 07513780630 —
          Polizza Assicurativa Professionale Sara Assicurazioni n. 71 48635IF
        </p>
        <p className="mt-2 text-xs leading-relaxed text-slate-500">
          Sedi: Napoli (Viale Augusto 162 &amp; P.tta Aniello Falcone 1) | Milano (Corso di Porta Romana 69)
        </p>
        <p className="mt-4 text-xs text-slate-600">© 2026 Studio Legale Avv. Giuseppe Napolitano. Tutti i diritti riservati.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
